/* eslint-disable */
import { Component, Input, TemplateRef } from '@angular/core';


@Component({
    selector: 'ng-customizable-slider-tooltip-wrapper',
    templateUrl: './tooltip-wrapper.component.html',
    styleUrls: ['./tooltip-wrapper.component.scss'],
    standalone: false
})
export class NgTooltipWrapperComponent {

	@Input() template	!: TemplateRef<any>;
	@Input() tooltip	!: string;
	@Input() placement	!: string;
	@Input() content	!: string;
}
